import {
    postUpdateNewsLetterRepo
  } from "../repositories/newsletter"
import { createSlice } from "@reduxjs/toolkit";

const updateNewsLetterSlice = createSlice({
      name:"updateNewsLetterReducer",
      initialState:{
        updateNewsLetterLoading: false,
        updateNewsLetterData: null,
        updateNewsLetterError: null,
        },

      reducers:{
        postUpdateNewsLetterLoading(state, action) {
            return {
                ...state,
                updateNewsLetterLoading: true,
            };
        },
        postUpdateNewsLetterSuccess(state, action) {
            return {
                ...state,
                updateNewsLetterLoading: false,
                updateNewsLetterData: action.payload,
            };
        },
        postUpdateNewsLetterFailure(state, action) {
            return {
                ...state,
                updateNewsLetterLoading: false,
                updateNewsLetterError: action.payload,
                
            };
        },
        clearPostUpdateNewsLetterReponse(state, action) {//remove
            return {
                ...state,
                updateNewsLetterData: null,
                updateNewsLetterError: null,
            };
        },  
}
})

export const {
    postUpdateNewsLetterLoading,
    postUpdateNewsLetterSuccess,
    postUpdateNewsLetterFailure,
    clearPostUpdateNewsLetterReponse,

} = updateNewsLetterSlice.actions;


export const postUpdateNewsLetter = (params) => {
    
    return async (dispatch) => {
        dispatch(postUpdateNewsLetterLoading());
        await  postUpdateNewsLetterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(postUpdateNewsLetterSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postUpdateNewsLetterFailure(error?.response?.data?.message));
                }
            });
    };
};
export default updateNewsLetterSlice.reducer;